import { Link } from 'react-router-dom';
import { navigationItems } from '../../data/navigation';
import { operationalProjects } from '../../data/operationalProjects';

const footerLinks = navigationItems.flatMap((item) => item.children || item);

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <Link className="brand" to="/">
            <span className="brand-mark">FS</span>
            <span>FactorStreet</span>
          </Link>
          <p>
            Factor Street E-commerce Services Pvt. Ltd. builds practical digital systems,
            learning platforms, technology products, and long-term business initiatives.
          </p>
        </div>

        <div>
          <h3>Company</h3>
          <ul>
            {footerLinks.map((item) => (
              <li key={item.path}>
                <Link to={item.path}>{item.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3>Operational Projects</h3>
          <ul>
            {operationalProjects.map((project) => (
              <li key={project.name}>
                <a href={project.url} rel="noreferrer" target="_blank">
                  {project.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3>Contact</h3>
          <p>
            <a href="mailto:hello@factorstreet.com">hello@factorstreet.com</a>
          </p>
        </div>
      </div>

      <div className="container footer-bottom">
        <span>© {new Date().getFullYear()} FactorStreet. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;
